import React from 'react';
import "./login.css";
import { Link } from 'react-router-dom';
import Loader from "../../common/loader/containers/loader_cont";
import Snackbar from "../../common/snackbar/components/snackbar";
import Logo from './logo.png';
const Login = (props) => {
  const [loginData, setLoginData] = React.useState({ aadharNo: '', dob: '' });
  const [aadharError, setAadharError] = React.useState('');
  const [dobError, setDobError] = React.useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLoginData({ ...loginData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let valid = true;
    if (!loginData.aadharNo || loginData.aadharNo.length !== 12) {
      setAadharError('Please enter valid 12-digit Aadhaar number');
      valid = false;
    } else { setAadharError(''); }
    if (!loginData.dob) {
      setDobError('Date of Birth is required');
      valid = false;
    } else { setDobError(''); }
    if (valid) props.super_login(loginData.aadharNo, loginData.dob);
  };

  return (
    <div className="neet-page">
      {/* Top Bar */}
      <div className="neet-top-bar">
        Government of India &nbsp;|&nbsp; Ministry of Health and Family Welfare &nbsp;|&nbsp; National Testing Agency
      </div>

      {/* Header */}
      <div className="neet-header">
        <div className="neet-header-inner">
          <div className="neet-logo-emblem"><img  className="neet-logo-emblem" src={Logo}></img></div>
          <div className="neet-header-text">
            <h1>Prayash NEET 2027 — Student Portal</h1>
            <h2>National Eligibility cum Entrance Test (Undergraduate)</h2>
            <div className="neet-subtitle">PRAYASH EDUCATION — OFFICIAL REGISTRATION PORTAL</div>
          </div>
        </div>
      </div>

      {/* Nav Bar */}
      <div className="neet-nav">
        <div className="neet-nav-inner">
          <span className="neet-nav-item active">Home</span>
          <span className="neet-nav-item">Notifications</span>
          <span className="neet-nav-item">Instructions</span>
          <span className="neet-nav-item">Contact</span>
        </div>
      </div>

      {/* Main Content */}
      <div className="neet-main">
        {/* Info Panel */}
        <div className="neet-info-panel" style={{ flex: 1 }}>
          <div className="neet-info-panel-header"> Important Notices</div>
          <ul className="neet-notice-list">
            <li>Candidates must have passed 10+2 or equivalent with Physics, Chemistry & Biology.</li>
            <li>Aadhaar card is mandatory for registration. Please keep it handy.</li>
            <li>Upload passport-size photograph (white background, recent).</li>
            <li>Upload sign & Aadhaar card as per NTA guidelines.</li>
            <li>Application once submitted cannot be edited — please review carefully.</li>
            <li>Helpline: +91 6371862025 | Email: info@pvmodisha.in</li>
          </ul>

          <div className="neet-info-panel-header" style={{ marginTop: 0 }}>Important Dates</div>
          <div className="neet-important-dates">
            {[
              ["Registration Opens", "09 June 2026"],
              ["Last Date to Apply", "02 July 2026"],
              // ["Application Correction", "01–05 Jun 2027"],
              ["Admit Card Release", "3rd Jul 2026"],
              ["Exam Date", "5 Jul 2026"],
              ["Result Declaration Updated soon"],
            ].map(([label, value]) => (
              <div className="neet-date-item" key={label}>
                <span className="neet-date-label">{label}</span>
                <span className="neet-date-value">{value}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Login Panel */}
        <div className="neet-login-panel">
          <div className="neet-login-card">
            <div className="neet-login-card-header">
              <h3> Candidate Login</h3>
              <p>Use your Aadhaar number & Date of Birth</p>
            </div>
            <div className="neet-login-form">
              <div className="neet-form-group">
                <label className="neet-form-label">Aadhaar Number <span>*</span></label>
                <input
                  className={`neet-form-input ${aadharError ? 'error' : ''}`}
                  type="text"
                  name="aadharNo"
                  maxLength={12}
                  placeholder="Enter 12-digit Aadhaar No."
                  value={loginData.aadharNo}
                  onChange={handleInputChange}
                />
                {aadharError && <div className="neet-error-text">{aadharError}</div>}
              </div>

              <div className="neet-form-group">
                <label className="neet-form-label">Date of Birth <span>*</span></label>
                <input
                  className={`neet-form-input ${dobError ? 'error' : ''}`}
                  type="date"
                  name="dob"
                  value={loginData.dob}
                  onChange={handleInputChange}
                />
                {dobError && <div className="neet-error-text">{dobError}</div>}
              </div>

              <button className="neet-login-btn" onClick={handleSubmit}>
                Login to Portal
              </button>

              {/* <div className="neet-register-link">
                New Candidate? <Link to="/register">Register Here</Link>
              </div> */}

              <div className="neet-help-box">
                ⚠️ For login issues, contact:<br />
                <strong>6371862025</strong> or <strong>info@pvmodisha.in</strong>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="neet-footer">
        © 2027 PRAYASH EDUCATION | NEET 2027 Candidate Portal | All Rights Reserved<br />
        <a href="#">Privacy Policy</a> | <a href="#">Terms of Use</a> | <a href="#">Help & FAQ</a>
      </div>

      <Loader />
      <Snackbar
        open={props.snackbar.response_received}
        close_snack_bar={props.close_snack_bar}
        message={props.snackbar.message}
      />
    </div>
  );
};

export default Login;
